// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1102":"email-triage-page","3958":"compose-email-modal","5115":"dashboard-page","6956":"templates-page"}[chunkId] + "." + {"1102":"1b2c951f","3958":"1b2c951f","5115":"1b2c951f","6956":"1b2c951f"}[chunkId] + ".chunk.css";
};